import { ajaxHandler, spinnerElem, toast } from "./utilities/utilities";

	document.addEventListener("DOMContentLoaded", function () {
		const button = document.querySelector("button[data-token]");
		
		if (button) {
			button.addEventListener("click", async function (e) {
				const licenseConnectToken = e.currentTarget.getAttribute("data-token");
				const formData = new FormData();
				formData.append('token', licenseConnectToken);
				formData.append('action', 'platform_connect_license');

                const btnPrevHtml = e.currentTarget.innerHTML;

                try {

                    button.disabled = true;
                    button.innerHTML = `${spinnerElem}`;
                    // Make an AJAX request using Fetch API
                    const res = await ajaxHandler( formData );                    
                    if ( res ) {
                        const {success, data} = res;
                        if (success) {
                            toast.success('License connected successfully!')
                            window.location.href = data;
                        } else {
                            toast.error(data)
                        }
                    } else {
                        toast.error('Something went wrong!');
                    }
                } catch (error) {
                    toast.error(error)
                } finally {
                    button.disabled = false;
                    button.innerHTML = btnPrevHtml;
                }
			});
		}
	});
